<template>
  <div class="carousel">
    <!-- 左右按钮 -->
    <button class="btn-left" @click="scrollLeft"><img src="/image/portalimg/btn-left.png"></button>
    <button class="btn-right" @click="scrollRight"><img src="/image/portalimg/btn-right.png"></button>

    <!-- 轮播内容 -->
    <div class="FrameHome1" ref="frame">
      <div class="carousel-inner" ref="inner" :style="innerStyle">
        <!-- 轮播项 1 -->
        <div class="carousel-item">
          <div class="frameHome1bg5cont" @click="goToSptResources">
            <div class="frameHome1baseWid ">
              <div class="clickBtn">
                <button class="buyBtn">立即购买</button>
              </div>
            </div>
          </div>
        </div>

        <!-- 轮播项 2 -->
        <div class="carousel-item">
          <div class="frameHome1bg1cont">
            <div class="frameHome1baseWid ">
              <div class="frameHome1Txt lf">
                <h4 class="frameHome1Txttitle">智算、超算、通用计算、量子计算四算融合</h4>
                <div class="frameHome1TxtCont3">&nbsp;</div>
                <div class="frameHome1TxtCont1">算力城市</div>
                <div class="frameHome1TxtCont3">&nbsp;</div>
                <div class="frameHome1TxtCont3">创新驱动，科研赋能，智领科技</div>
                <div class="frameHome1TxtCont3">强大计算，多元一体，无限可能</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 轮播项 3 -->
        <div class="carousel-item">
          <div class="frameHome1bg3cont">
            <div class="frameHome1baseWid">
              <div class="frameHomeBanner04 lf">
                <h4 class="frameHome1TxttitleWhite">算力城市</h4>
                <div class="frameHome1TxtCont1White">&nbsp;</div>
                <div class="frameHome1TxtCont1White">大规模先进算力</div>
                <div class="frameHome1TxtCont3White">配备尖端的大规模智算算力，满足智算时代的算力需求</div>
                <div class="frameHome1TxtCont3White">为人工智能、科学计算、工业仿真提供无与伦比的计算性能</div>
                <div class="frameHome1TxtCont3White">&nbsp;</div>
                <div class="frameHome1TxtCont1White">远距离高通量连接</div>
                <div class="frameHome1TxtCont3White">面向全国主要城市提供高通量、低时延、低抖动的数据传输专线</div>
                <div class="frameHome1TxtCont3White">确保数据传输的高效性与稳定性，助力企业实现无缝远程协作</div>
                <div class="frameHome1TxtCont3White">&nbsp;</div>
                <div class="frameHome1TxtCont1White">人工智能 + 行业创新</div>
                <div class="frameHome1TxtCont3White">支持前沿的人工智能研究与开发，激发各行业的创新潜能</div>
                <div class="frameHome1TxtCont3White">推动政务、教育、农业、交通、能源各行各业智能化转型</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 轮播项 4 -->
        <div class="carousel-item">
          <div class="frameHome1bg2cont">
            <div class="frameHome1baseWid ">
              <div class="frameHomeBanner02 rf">
                <h4 class="frameHome1Txttitle">算力城市：AI + 算力 + 行业应用</h4>
                <div class="frameHome1TxtCont1">&nbsp;</div>
                <div class="frameHome1TxtCont1">驱动数字转型，构建智慧城市</div>
                <div class="frameHome1TxtCont3">支撑数字政府、智慧城市、公共服务和数字经济发展，助力社会进步</div>
                <div class="frameHome1TxtCont3">&nbsp;</div>
                <div class="frameHome1TxtCont1">汇聚顶尖算力，激发创新潜能</div>
                <div class="frameHome1TxtCont3">致力于科研与技术创新，提供先进的算法平台，为技术发展注入新动力</div>
                <div class="frameHome1TxtCont3">&nbsp;</div>
                <div class="frameHome1TxtCont1">赋能市场应用，助力商业成功</div>
                <div class="frameHome1TxtCont3">提供灵活多样的计算能力和服务，帮助企业赢得竞争先机</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 轮播项 5 -->
        <div class="carousel-item">
          <div class="frameHome1bg4cont">
            <div class="frameHome1baseWid">
              <div class="frameHomeBanner06 rf">
                <h4 class="frameHome1Txttitle">算力城市：绿色未来，共筑可持续发展</h4>
                <div class="frameHome1TxtCont1">&nbsp;</div>
                <div class="frameHome1TxtCont1">绿电 + 智算</div>
                <div class="frameHome1TxtCont3">丰富的风光资源，构建未来的绿色算力</div>
                <div class="frameHome1TxtCont3">共建清洁美丽世界，为后代留下一片蓝天</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BannerCarousel',
  data() {
    return {
      currentIndex: 0,
      itemWidth: 1920, // 每个轮播项的宽度
    }
  },
  computed: {
    innerStyle() {
      return {
        transform: `translateX(${-this.currentIndex * this.itemWidth}px)`,
        transition: 'transform 0.5s ease-in-out',
      };
    }
  },
  methods: {
    scrollLeft() {
      this.currentIndex = (this.currentIndex > 0) ? this.currentIndex - 1 : 4; // 5个轮播项
    },
    scrollRight() {
      this.currentIndex = (this.currentIndex < 4) ? this.currentIndex + 1 : 0; // 5个轮播项
    },
    goToSptResources() {
      this.$router.push({
        path: '/sptResources',
      });
    }
  }
}
</script>

<style scoped>
.carousel {
  position: relative;
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;
}

.btn-left, .btn-right {
  position: absolute;
  height: 60px;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
  z-index: 10; /* 确保按钮在图片上方 */
}

.btn-left {
  left: 10px; /* 根据需要调整距离 */
}

.btn-right {
  right: 10px; /* 根据需要调整距离 */
}
.btn-left img, .btn-right img{
  width: 15px;
}

.FrameHome1 {
  width: 100%;
  overflow: hidden;
}

.carousel-inner {
  display: flex;
  width: 9600px; /* 5 * 1920px */
}

.carousel-item {
  min-width: 1920px;
  box-sizing: border-box;
}

/* 背景图样式 */
.frameHome1bg1cont {
  background: url('/image/portalimg/frameHome1bg1small.png') no-repeat center center;
  min-height: 500px;
  margin: 0 auto;
  background-size: 100%;
}

.frameHome1bg2cont {
  background: url('/image/portalimg/frameHome1bg2small.png') no-repeat center center;
  min-height: 500px;
  margin: 0 auto;
  background-size: 1920px 500px;
}

.frameHome1bg3cont {
  background: url('/image/portalimg/frameHome1bg3small.png') no-repeat center center;
  min-height: 500px;
  margin: 0 auto;
  background-size: 100%;
}

.frameHome1bg4cont {
  background: url('/image/portalimg/frameHome1bg4small.png') no-repeat center center;
  min-height: 500px;
  margin: 0 auto;
  background-size: 100%;
}

.frameHome1bg5cont {
  background: url('/image/portalimg/domestic/bannerH200.png') no-repeat center center;
  min-height: 500px;
  margin: 0 auto;
  background-size: 100%;
  cursor: pointer;
}

/* 文本样式 */
.frameHome1Txt {
  width: 805px;
  margin: 110px 100px 0 244px
}

.frameHomeBanner04 {
  width: 645px;
  margin: 40px 0 0 249px;
}
.frameHomeBanner06{
  margin: 160px 200px 0 0;
}

.frameHomeBanner02{
  margin: 66px 260px 0 244px
}

.frameHome1Txttitle {
  font-size: 26px;
  color: #1C1C1C;
  letter-spacing: 2.33px;
  font-weight: 400;
  padding-bottom: 10px;
}

.frameHome1TxtCont1, .frameHome1TxtCont2 {
  font-size: 24px;
  color: #1C1C1C;
  letter-spacing: 4.67px;
  line-height: 25px;
  font-weight: 500;
  padding-bottom: 0px;
}

.frameHome1TxtCont3 {
  padding-top: 20px;
  font-size: 15px;
  color: #1C1C1C;
  letter-spacing: 4.67px;
  line-height: 20px;
  font-weight: 400;
}

.frameHome1TxttitleWhite {
  font-size: 26px;
  color: #F1F1FF;
  letter-spacing: 2.33px;
  font-weight: 400;
  padding-bottom: 10px;
}

.frameHome1TxtCont1White, .frameHome1TxtCont2White {
  font-size: 24px;
  color: #FFF1FF;
  letter-spacing: 4.67px;
  line-height: 15px;
  font-weight: 500;
  padding-bottom: 0px;
}

.frameHome1TxtCont3White {
  padding-top: 15px;
  font-size: 15px;
  color: #F1F1FF;
  letter-spacing: 4.67px;
  line-height: 22px;
  font-weight: 400;
}

/* 按钮样式 */
.clickBtn{
  width: 200px;
  height: 52px;
  margin: 0 auto;
  padding-top: 399px;
}

.buyBtn{
  background: #FF8028;
  box-shadow: 0px 2px 4px 0px rgba(7,0,196,0.5);
  border: 0;
  border-radius: 8px;
  width: 200px;
  height: 52px;
  text-align: center;
  font-size: 24px;
  color: #fff;
  font-weight: 500;
  cursor: pointer;
  font-weight: bold;
}
</style>